/**
 * A choice control is a field in miniature: the raised ground and hairline edge Input uses.
 * Checked and indeterminate take the blue fill Toggle uses for on.
 */
export const choiceControlClasses = [
  'size-4 shrink-0 cursor-pointer border outline-none',
  'transition-[background-color,border-color] duration-150 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none',
  'bg-background-raised border-border hover:bg-element-hover hover:border-hover active:bg-element-active',
  'focus-visible:focus-ring',
  // The edge matches the solid fill, not the tone's border token.
  'data-[checked]:bg-info data-[checked]:hover:bg-info-hover data-[checked]:active:bg-info-active data-[checked]:border-[color:var(--info)] data-[checked]:hover:border-[color:var(--info-hover)] data-[checked]:active:border-[color:var(--info-active)]',
  'data-[indeterminate]:bg-info data-[indeterminate]:hover:bg-info-hover data-[indeterminate]:border-[color:var(--info)] data-[indeterminate]:hover:border-[color:var(--info-hover)]',
  'is-invalid:border-[color:var(--danger)] is-invalid:hover:border-danger-hover is-invalid:focus-visible:focus-ring-danger',
  // One wash whether checked or not, like a disabled Button, so the mark carries the answer.
  // Important because the checked hover fills outrank a single data variant.
  'data-[disabled]:!bg-element-disabled data-[disabled]:!border-disabled data-[disabled]:cursor-not-allowed',
].join(' ')
